import React from 'react';
import AdvancedSearchFooter from '../../../../advanced-search-footer';
import { SearchFooter } from '@atlassian/search-dialog';
export const GetDefaultFooter = ({
  productState,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(SearchFooter, null, /*#__PURE__*/React.createElement(AdvancedSearchFooter, rest));
};